import i18n from 'i18n-js';
import * as types from './types';
import { getErrorMessage } from 'utils';
import { uiActions } from 'state/modules/UI';
import * as organizationActions from 'services/api/organizations';

export const fetchPublicOrganizationsRequest = () => ({
  type: types.FETCH_PUBLIC_ORGANIZATIONS_REQUEST,
});

export const fetchPublicOrganizationsSuccess = (payload) => ({
  type: types.FETCH_PUBLIC_ORGANIZATIONS_SUCCESS,
  payload,
});

export const fetchPublicOrganizationsFailed = () => ({
  type: types.FETCH_PUBLIC_ORGANIZATIONS_FAILED,
});

export const fetchPublicOrganizations = () => {
  return async (dispatch) => {
    dispatch(fetchPublicOrganizationsRequest());

    const response = await organizationActions.fetchPublicOrganizations();

    if (response.ok) {
      return dispatch(fetchPublicOrganizationsSuccess(response.data));
    }
    dispatch(fetchPublicOrganizationsFailed());
  };
};

export const fetchOrganizationByIdRequest = () => ({
  type: types.FETCH_ORGANIZATION_BY_ID_REQUEST,
});

export const fetchOrganizationByIdSuccess = (payload) => ({
  type: types.FETCH_ORGANIZATION_BY_ID_SUCCESS,
  payload,
});

export const fetchOrganizationByIdFailed = () => ({
  type: types.FETCH_ORGANIZATION_BY_ID_FAILED,
});

export const fetchOrganizationById = (id) => {
  return async (dispatch) => {
    dispatch(fetchOrganizationByIdRequest());

    const response = await organizationActions.fetchOrganizationById(id);

    if (response.ok) {
      return dispatch(fetchOrganizationByIdSuccess(response.data));
    }
    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );

    dispatch(fetchOrganizationByIdFailed(error));
  };
};

export const fetchUpdateOrganizationRequest = () => ({
  type: types.FETCH_UPDATE_ORGANIZATION_REQUEST,
});

export const fetchUpdateOrganizationSuccess = (payload) => ({
  type: types.FETCH_UPDATE_ORGANIZATION_SUCCESS,
  payload,
});

export const fetchUpdateOrganizationFailed = (errors) => ({
  type: types.FETCH_UPDATE_ORGANIZATION_FAILED,
  errors,
});

export const fetchUpdateOrganization = (id, data) => {
  return async (dispatch) => {
    dispatch(fetchUpdateOrganizationRequest());

    const response = await organizationActions.fetchUpdateOrganization(id, data);

    if (response.ok) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: 'Organization updated successfully',
        })
      );
      return dispatch(fetchUpdateOrganizationSuccess(response.data));
    }

    const formattedError = getErrorMessage(response.data, { fullObject: true });

    if (typeof formattedError === 'string') {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'error',
          message: formattedError,
        })
      );
      return dispatch(fetchUpdateOrganizationFailed());
    }

    let errors = {};

    formattedError?.length &&
      formattedError.map((val) => {
        return (errors[val.field] = val.message);
      });

    dispatch(fetchUpdateOrganizationFailed(errors));
  };
};

export const resetUpdateOrganization = () => (dispatch) => {
  dispatch({
    type: types.RESET_UPDATE_ORGANIZATION_SUCCESS,
  });
};

const fetchUploadOrganizationLogoRequest = () => ({
  type: types.UFETCH_PLOAD_ORGANIZATION_LOGO_REQUEST,
});

const fetchUploadOrganizationLogoSuccess = (payload) => ({
  type: types.UFETCH_PLOAD_ORGANIZATION_LOGO_SUCCESS,
  payload,
});

const fetchUploadOrganizationLogoFailed = () => ({
  type: types.FETCH_UPLOAD_ORGANIZATION_LOGO_FAILED,
});

export const fetchUploadOrganizationLogo = (organizationId, file) => {
  return async (dispatch) => {
    dispatch(fetchUploadOrganizationLogoRequest());

    let data = new FormData();
    data.append('data', file);
    const response = await organizationActions.uploadLogo(organizationId, data);

    if (response.ok) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: 'Logo uploaded successfully',
        })
      );
      return dispatch(fetchUploadOrganizationLogoSuccess(response.data));
    }

    const error = getErrorMessage(response.data);

    dispatch(fetchUploadOrganizationLogoFailed());
    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: getErrorMessage(error),
      })
    );
  };
};

export const deleteOrganizationLogo = (organizationId) => {
  return async (dispatch) => {
    dispatch(fetchUploadOrganizationLogoRequest());

    const response = await organizationActions.deleteOrganizationLogo(organizationId);

    if (response.ok) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: 'Logo deleted successfully',
        })
      );
      dispatch(fetchUploadOrganizationLogoSuccess());
      return dispatch(fetchOrganizationById(organizationId));
    }

    const error = getErrorMessage(response.data);

    dispatch(fetchUploadOrganizationLogoFailed());
    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: getErrorMessage(error),
      })
    );
  };
};

// Reset upload organization logo
const resetUploadOrganizationLogoSuccess = (payload) => ({
  type: types.RESET_UPLOAD_ORGANIZATION_LOGO_SUCCESS,
  payload,
});

export const resetUploadOrganizationLogo = () => {
  return async (dispatch) => {
    dispatch(resetUploadOrganizationLogoSuccess());
  };
};

const fetchAvailablesBrokersRequest = () => ({
  type: types.FETCH_AVAILABLES_BROKERS_REQUEST,
});

const fetchAvailablesBrokersSuccess = (payload) => ({
  type: types.FETCH_AVAILABLES_BROKERS_SUCCESS,
  payload,
});

const fetchAvailablesBrokersFailed = (payload) => ({
  type: types.FETCH_AVAILABLES_BROKERS_FAILED,
  payload,
});

export const fetchAvailablesBrokers = (params) => async (dispatch) => {
  dispatch(fetchAvailablesBrokersRequest());

  const response = await organizationActions.getAvailablesBrokers(params);

  if (response.ok) {
    return dispatch(
      fetchAvailablesBrokersSuccess({
        data: response.data,
      })
    );
  }

  const formattedError = getErrorMessage(response?.data);

  dispatch(fetchAvailablesBrokersFailed({ errors: formattedError }));

  if (typeof formattedError === 'string') {
    return dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: formattedError,
      })
    );
  }

  dispatch(
    uiActions.handleShowSnackbar({
      type: 'error',
      message: formattedError[0].message,
    })
  );
};

const fetchBrokerSchemaRequest = () => ({
  type: types.FETCH_BROKER_SCHEMA_REQUEST,
});

const fetchBrokerSchemaSuccess = (payload) => ({
  type: types.FETCH_BROKER_SCHEMA_SUCCESS,
  payload,
});

const fetchBrokerSchemaFailed = () => ({
  type: types.FETCH_BROKER_SCHEMA_FAILED,
});

export const resetBrokerSchema = () => (dispatch) =>
  dispatch({
    type: types.FETCH_RESET_BROKER_SCHEMA,
  });

export const fetchBrokerSchema = (id) => async (dispatch) => {
  dispatch(fetchBrokerSchemaRequest());
  const response = await organizationActions.getBrokerSchema(id);
  if (response.ok) {
    return dispatch(fetchBrokerSchemaSuccess(response.data));
  }
  const formattedError = getErrorMessage(response?.data);
  dispatch(fetchBrokerSchemaFailed());
  if (typeof formattedError === 'string') {
    return dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: formattedError,
      })
    );
  }
  dispatch(
    uiActions.handleShowSnackbar({
      type: 'error',
      message: formattedError[0].message,
    })
  );
};

const fetchCreateAccountRequest = () => ({
  type: types.FETCH_CREATE_PAYMENT_ACCOUNT_REQUEST,
});

const fetchCreateAccountSuccess = (payload) => ({
  type: types.FETCH_CREATE_PAYMENT_ACCOUNT_SUCCESS,
  payload,
});

const fetchCreateAccountFailed = () => ({
  type: types.FETCH_CREATE_PAYMENT_ACCOUNT_FAILED,
});

export const fetchCreateAccount =
  (id, payload = {}, onSuccess) =>
  async (dispatch) => {
    dispatch(fetchCreateAccountRequest());
    const redirect = payload?.code ? false : true;
    const response = await organizationActions.createAccountOnboarding(id, payload);
    if (response.ok) {
      onSuccess && onSuccess();
      if (redirect) {
        dispatch(
          uiActions.handleShowSnackbar({
            type: 'success',
            message: i18n.t('organization.account_created'),
          })
        );
      }
      return dispatch(fetchCreateAccountSuccess({ ...response.data, redirect }));
    }

    const formattedError = getErrorMessage(response?.data);
    dispatch(fetchCreateAccountFailed());
    if (typeof formattedError === 'string') {
      return dispatch(
        uiActions.handleShowSnackbar({
          type: 'error',
          message: formattedError,
        })
      );
    }
    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: formattedError[0].message,
      })
    );
  };

const fetchPaymentOnboardRequest = () => ({
  type: types.FETCH_PAYMENT_ONBOARD_REQUEST,
});

const fetchPaymentOnboardSuccess = (payload) => ({
  type: types.FETCH_PAYMENT_ONBOARD_SUCCESS,
  payload,
});

const fetchPaymentOnboardFailed = () => ({
  type: types.FETCH_PAYMENT_ONBOARD_FAILED,
});

export const fetchOnboard = (id) => async (dispatch) => {
  dispatch(fetchPaymentOnboardRequest());

  const response = await organizationActions.fetchPaymentOnboarding(id);

  if (response.ok) {
    return dispatch(fetchPaymentOnboardSuccess({ ...response.data, redirect: true }));
  }

  const formattedError = getErrorMessage(response?.data);

  dispatch(fetchPaymentOnboardFailed());

  if (typeof formattedError === 'string') {
    return dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: formattedError,
      })
    );
  }

  dispatch(
    uiActions.handleShowSnackbar({
      type: 'error',
      message: formattedError[0].message,
    })
  );
};

const fetchAccountDetailsRequest = () => ({
  type: types.FETCH_ACCOUNT_DETAILS_REQUEST,
});

const fetchAccountDetailsSuccess = (payload) => ({
  type: types.FETCH_ACCOUNT_DETAILS_SUCCESS,
  payload,
});

const fetchAccountDetailsFailed = () => ({
  type: types.FETCH_ACCOUNT_DETAILS_FAILED,
});

export const fetchAccountDetails = (id) => async (dispatch) => {
  dispatch(fetchAccountDetailsRequest());

  const response = await organizationActions.getAccountStatus(id);

  if (response.ok) {
    return dispatch(fetchAccountDetailsSuccess(response.data));
  }

  const formattedError = getErrorMessage(response?.data);

  dispatch(fetchAccountDetailsFailed());

  if (typeof formattedError === 'string') {
    return dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: formattedError,
      })
    );
  }

  dispatch(
    uiActions.handleShowSnackbar({
      type: 'error',
      message: formattedError[0].message,
    })
  );
};

const fetchLinkAccountRequest = () => ({
  type: types.FETCH_LINK_PAYMENT_ACCOUNT_REQUEST,
});

const fetchLinkAccountSuccess = (payload) => ({
  type: types.FETCH_LINK_PAYMENT_ACCOUNT_SUCCESS,
  payload,
});

const fetchLinkAccountFailed = () => ({
  type: types.FETCH_LINK_PAYMENT_ACCOUNT_FAILED,
});

export const fetchLinkAccount = (id) => async (dispatch) => {
  dispatch(fetchLinkAccountRequest());

  const response = await organizationActions.linkAccount(id);

  if (response.ok) {
    return dispatch(fetchLinkAccountSuccess({ ...response.data, redirect: true }));
  }

  const formattedError = getErrorMessage(response?.data);
  dispatch(fetchLinkAccountFailed());

  if (typeof formattedError === 'string') {
    return dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: formattedError,
      })
    );
  }

  dispatch(
    uiActions.handleShowSnackbar({
      type: 'error',
      message: formattedError[0].message,
    })
  );
};

export const resetAccountOnboarding = () => (dispatch) =>
  dispatch({
    type: types.FETCH_RESET_CREATE_ACCOUNT_ONBOARDING,
  });

const fetchDeleteOrganizationToBrokersRequest = () => ({
  type: types.FETCH_DELETE_ORGANIZATION_TO_BROKERS_REQUEST,
});

const fetchDeleteOrganizationToBrokersRequestSuccess = (payload) => ({
  type: types.FETCH_DELETE_ORGANIZATION_TO_BROKERS_SUCCESS,
  payload,
});

const fetchDeleteOrganizationToBrokersRequestFailed = () => ({
  type: types.FETCH_DELETE_ORGANIZATION_TO_BROKERS_FAILED,
});

const fetchOrganizationToBrokerRequest = () => ({
  type: types.FETCH_ORGANIZATION_TO_BROKER_REQUEST,
});

const fetchOrganizationToBrokerSuccess = (payload) => ({
  type: types.FETCH_ORGANIZATION_TO_BROKER_SUCESS,
  payload,
});

const fetchOrganizationToBrokerFailed = () => ({
  type: types.FETCH_ORGANIZATION_TO_BROKER_FAILED,
});

export const resetBrokersState = () => (dispatch) => {
  return dispatch({
    type: types.RESET_ORGANIZATION_TO_BROKER,
  });
};

export const fetchDeleteOrganizationsToBrokers = (org_to_broker_id) => async (dispatch) => {
  dispatch(fetchDeleteOrganizationToBrokersRequest());

  const response = await organizationActions.fetchDeleteOrganizationsToBrokers(org_to_broker_id);

  if (response.ok) {
    dispatch(
      uiActions.handleShowSnackbar({
        type: 'success',
        message: i18n.t('organization.broker_disconnected'),
      })
    );
    return dispatch(fetchDeleteOrganizationToBrokersRequestSuccess());
  }

  const formattedError = getErrorMessage(response?.data);
  dispatch(fetchDeleteOrganizationToBrokersRequestFailed());

  if (typeof formattedError === 'string') {
    return dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: formattedError,
      })
    );
  }

  dispatch(
    uiActions.handleShowSnackbar({
      type: 'error',
      message: formattedError[0].message,
    })
  );
};

const fetchEditOrganizationToBrokersRequest = () => ({
  type: types.FETCH_EDIT_ORGANIZATION_TO_BROKERS_REQUEST,
});

const fetchEditOrganizationToBrokersRequestSuccess = (payload) => ({
  type: types.FETCH_EDIT_ORGANIZATION_TO_BROKERS_SUCCESS,
  payload,
});

const fetchEditOrganizationToBrokersRequestFailed = (errors) => ({
  type: types.FETCH_EDIT_ORGANIZATION_TO_BROKERS_FAILED,
  errors,
});

export const editOrganizationToBrokers = (org_to_broker_id, payload) => async (dispatch) => {
  dispatch(fetchEditOrganizationToBrokersRequest());

  const response = await organizationActions.editOrganizationsToBrokers(org_to_broker_id, payload);

  if (response.ok) {
    return dispatch(fetchEditOrganizationToBrokersRequestSuccess(response?.data));
  }

  const formattedError = getErrorMessage(response?.data);
  dispatch(fetchEditOrganizationToBrokersRequestFailed(formattedError));
};

export const fetchOrganizationToBrokerById = (org_to_broker_id) => async (dispatch) => {
  dispatch(fetchOrganizationToBrokerRequest());

  const response = await organizationActions.fetchOrganizationToBrokerById(org_to_broker_id);

  if (response.ok) {
    return dispatch(fetchOrganizationToBrokerSuccess(response?.data));
  }
  const formattedError = getErrorMessage(response?.data);
  dispatch(fetchOrganizationToBrokerFailed());

  if (typeof formattedError === 'string') {
    return dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: formattedError,
      })
    );
  }

  dispatch(
    uiActions.handleShowSnackbar({
      type: 'error',
      message: formattedError[0].message,
    })
  );
};
